import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_share",
  "use": "svg_share-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"svg_share\"><path d=\"M2.542 7.625v5.083a1.27 1.27 0 0 0 1.27 1.271h7.626a1.27 1.27 0 0 0 1.27-1.27V7.624M10.166 3.813 7.625 1.27 5.083 3.813M7.625 1.27v8.261\" stroke=\"currentColor\" stroke-width=\"1.271\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol